import { cva, type VariantProps } from "class-variance-authority";
import clsx from "clsx";
import { Icon } from "../icons";
import type { ChildrenProps, ClassNameProps } from "../types";

/** Props Interface */
interface DataGridValueProps
	extends ClassNameProps,
		ChildrenProps,
		VariantProps<typeof dataGridValue> {
	onEdit?: () => void;
	append?: React.ReactNode;
	isTabular?: boolean;
}

export function DataGridValue({
	children,
	className,
	onEdit,
	justify,
	append,
	isTabular = true,
}: DataGridValueProps) {
	/** Constants */
	const classes = dataGridValue({ justify });

	/** Render */
	return (
		<div className={clsx("h-stack min-w-0 overflow-hidden", onEdit && "cursor-pointer", classes)}>
			<p className={clsx("font-medium! text-md! truncate", isTabular && "tabular-nums", className)}>
				{children}
			</p>
			{append || onEdit ? (
				<div className="h-stack">
					{append ? append : null}
					{onEdit ? (
						<span
							className="opacity-50 hover:opacity-100 -mx-2 px-2"
							onClick={onEdit}
						>
							<Icon name="Edit" />
						</span>
					) : null}
				</div>
			) : null}
		</div>
	);
}

const dataGridValue = cva(["gap-8"], {
	variants: {
		justify: {
			between: ["justify-between"],
			end: ["justify-end"],
		},
	},
});
